<template>
  <div>
    <section class="statistics">
      <AdvanceFilter :is-modal-open="isModalOpen" />
      <div class="statistics__bar-settings">
        <BarSettings @close="onClose" />
      </div>
      <div class="statistics__cont-header">
        <HeaderGame
          :size="size"
          :available-games="availableGames"
          :are-games-visible="isFromBet"
          :is-inner-component="isInnerComponent"
          @game-change="onGameChanged"
        />
      </div>
      <div class="statistics__cont-menu">
        <HeaderMenu ref="headerMenu" />
      </div>
      <div class="statistics__cont-sub-menu" v-if="menuOptionActive === 'stats'">
        <HeaderSubMenu />
      </div>
      <div class="statistics__cont-sections">
        <KeepAlive :include="arrayKeepAliveComponents">
          <Component
            :is="currentComponent"
            :is-from-bet="isFromBet"
            :bet-categories="betCategories"
            :game="game.gameId"
            :game-value="objectGame"
          />
        </KeepAlive>
      </div>
    </section>
  </div>
</template>

<script>
import options from '@/data/next/options';
import { connectSocket, disconnectSocket } from '@/utils/socketConnection';
import { mapActions, mapGetters, mapMutations, mapState } from 'vuex';
import axios from 'axios';
import { btnLive, clickBtnAvanzado } from '@/utils/analytics';

export default {
  name: 'Statistics',
  components: {
    ItemNextMatches: () => import('@/components/Elements/NextMatches/ItemNextMatches'),
    BarSettings: () => import('@/components/Sections/Statistics/BarSettings'),
    HeaderGame: () => import('@/components/Sections/Statistics/HeaderGame'),
    HeaderMenu: () => import('@/components/Sections/Statistics/HeaderMenu'),
    HeaderSubMenu: () => import('@/components/Sections/Statistics/HeaderSubMenu'),
    AdvanceFilter: () => import('@/components/Elements/NextMatches/AdvanceFilter.vue'),
    Resumen: () => import('@/components/Sections/Statistics/Summary'),
    Barras: () => import('@/components/Sections/NextMatches/Barras'),
    Distribution: () => import('@/components/Sections/NextMatches/Distribution'),
    TendenciaLive: () => import('@/components/Sections/NextMatches/TrendLive'),
    Xg: () => import('@/components/Sections/NextMatches/Xg.vue'),
    LineupPlayers: () => import('@/components/Sections/LineUp/LineupPlayers'),
    PlayByPlay: () => import('@/components/Sections/PlayByPlay'),
  },
  props: {
    isInnerComponent: {
      type: Boolean,
      default: false,
    },
    game: {
      type: Object,
      default: () => ({
        gameId: 0,
        seasonId: 0,
      }),
    },
    avoidCleanBeforeDestroy: {
      type: Boolean,
      default: false,
    },
    isModalOpen: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      viewOptions: null,
      size: 769,
      tournamentsUrl: 'https://17zyhpyc7c.execute-api.us-west-2.amazonaws.com/prod/tournaments',
      gamesUrl: 'https://qyyibs1w0d.execute-api.us-west-2.amazonaws.com/prod/calendar/gamesBySeason?',
      // gamesUrl: 'https://kkd48smit2.execute-api.us-west-2.amazonaws.com/qa/calendar/gamesBySeason?',
      availableGames: [],
      isFromBet: false,
      defaultFilter: null,
      betCategories: [],
      lastGame: {
        gameId: 0,
        seasonId: 0,
      },
      arrayKeepAliveComponents: ['Resumen', 'TendenciaLive', 'PlayByPlay', 'LineupPlayers'],
    };
  },
  computed: {
    ...mapState('nextGeneral', ['showLiveData', 'selectedAnalysis', 'gameForAnalysis']),
    ...mapGetters('nextGeneral', ['gameId', 'menuOptionActive', 'showLive']),
    ...mapGetters('nextGeneral', ['idAssetSelected', 'gameId', 'menuOptionActive']),
    ...mapGetters('loginGeneral', ['getPremiumAccount']),
    ...mapState('general', ['tournamentSelected']),
    objectGame() {
      const objectGame = {
        ...this.game,
      };
      if (!objectGame.dateTimeUTC) {
        objectGame.dateTimeUTC = this.gameForAnalysis.date_time_utc;
      }
      if (!objectGame.status && objectGame.status !== 0) {
        objectGame.status = this.gameForAnalysis.game_status;
      }
      // if (objectGame.stringSectionName) {
      //   this.setInitialSection();
      // }
      return objectGame;
    },
    isDesktop() {
      return this.size > 768;
    },
    currentComponent() {
      if (this.menuOptionActive === 'stats') {
        return this.viewOptions
          ? this.viewOptions.find(option => option.id === this.idAssetSelected).component
          : 'Resumen';
      } else if (this.menuOptionActive === 'mxm') {
        return 'PlayByPlay';
      } else if (this.menuOptionActive === 'lineups') {
        return 'LineupPlayers';
      }
      return '';
    },
    sectionName() {
      let currentName = '';
      switch (this.currentComponent) {
        case 'Resumen':
          currentName = 'Resumen';
          break;
        case 'Barras':
          currentName = 'Barras';
          break;
        case 'Distribucion':
          currentName = 'Distribución';
          break;
        case 'Fuerza':
          currentName = 'Fuerza';
          break;
        case 'Tabla':
          currentName = 'Tabla';
          break;
        case 'Cancha':
          currentName = 'Cancha Goles y Orígenes';
          break;
        case 'TendenciaLive':
          currentName = 'Tendencia';
          break;
        case 'GolstatsLive':
          currentName = 'Golstats LIVE';
          break;
        case 'Xg':
          currentName = 'xG';
          break;
      }
      return currentName;
    },
  },
  watch: {
    isModalOpen: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          connectSocket();
        } else {
          disconnectSocket();
        }
      },
    },
    getPremiumAccount(value) {
      if (this.getPremiumAccount && value) {
        connectSocket();
      }
      if (value && (this.$route.path.toLowerCase().includes('/matches') || this.isInnerComponent)) {
        this.reloadStatistics(true);
      }
    },
    game: {
      deep: true,
      immediate: true,
      handler(newValue) {
        const analysisGame = { ...newValue };
        // analysisGame.visitingTeam = analysisGame.awayTeam;
        // delete analysisGame.awayTeam;
        this.onGameChanged(analysisGame);
      },
    },
    gameForAnalysis(newValue) {
      this.updateShowLiveData(!!newValue.is_live && this.getPremiumAccount);
    },
    // '$socket.connected': {
    //   immediate: true,
    //   handler(newValue) {
    //     console.log('socket.connected, watcher: ', newValue);
    //     this.updateIsSocketConnected(newValue);
    //   },
    // },
  },
  methods: {
    ...mapMutations('nextGeneral', [
      'toggleShowLiveData',
      'toggleAdvanceFilter',
      'updateSelectedAnalysis',
      'updateIdAssetSelected',
      // 'updateIsSocketConnected',
      'setMenuOptionActive',
      'setHome',
      'setAway',
      'setRegularSeasonName',
      'updateShowLiveData',
    ]),
    ...mapMutations('xgGeneral', ['cleanXgStore', 'setTeamSelected']),
    ...mapMutations(['setIsSectionLoading']),
    ...mapActions('nextGeneral', ['cleanStats', 'cleanAllStats']),
    // setInitialSection() {
    //   setTimeout(() => {
    //     this.$refs.headerMenu.clickMenuOption(this.objectGame.stringSectionName);
    //   }, 10);
    // },
    onClickAvanzado() {
      clickBtnAvanzado(
        this.gameId,
        this.showLive,
        this.getPremiumAccount,
        this.getPreviewSectionAnalytics,
        this.getIsGolstats,
      );
      this.toggleAdvanceFilter();
    },
    switchShowLiveData() {
      btnLive(this.game_id, this.showLiveData, this.getPremiumAccount, this.getIsGolstats);

      if (this.getPremiumAccount) this.toggleShowLiveData();
      else this.SET_PREMIUM_MESSAGE(true);
    },
    setSize() {
      this.size = typeof this.$refs.matchAnalysis === 'undefined' ? this.size : this.$refs.matchAnalysis.clientWidth;
    },
    async generateGamesList() {
      try {
        const tournaments = await this.fetchTournaments(3);
        const mxLeague = tournaments.find(t => t.tournament.id === 1);
        const regularSeason = mxLeague.seasons[0];
        const seasons = [regularSeason.id];
        this.setRegularSeasonName(regularSeason.name);
        regularSeason.related_seasons.forEach(relatedSeason => {
          seasons.push(relatedSeason.id);
        });
        const { seasonsAndGames, seasonsAndTeams } = await this.fetchSeasonsGamesAndTeams(seasons, 3);
        const teamsMap = seasonsAndTeams.reduce((accumulator, seasonAndTeams) => {
          seasonAndTeams.teams.forEach(team => {
            if (!accumulator.has(accumulator.set(team.team_id))) {
              accumulator.set(team.team_id, team);
            }
          });
          return accumulator;
        }, new Map());
        const allGames = seasonsAndGames.reduce((accumulator, seasonAndGames) => {
          seasonAndGames.games.forEach(game => {
            // todo: change to status 1 to production
            if (game.game_status !== 1) {
              game.seasonId = seasonAndGames.season_id;
              game.datetimeMillis = new Date(game.date_time_utc).valueOf();
              game.homeTeam = teamsMap.get(game.home_team);
              game.visitingTeam = teamsMap.get(game.visiting_team);
              game.name = `${game.homeTeam.team_name} vs ${game.visitingTeam.team_name}`;
              accumulator.push(game);
            }
          });
          return accumulator;
        }, []);
        allGames.sort((a, b) => {
          return a.datetimeMillis - b.datetimeMillis;
        });
        this.availableGames = allGames;
      } catch (e) {
        throw new Error(e);
      }
    },
    /**
     * @author Alejandro Martinez
     * @param {number} retries - Times to retry the request
     * @return {Promise<Array>} last5gamesInfo
     */
    async fetchTournaments(retries = 3) {
      // const seasonApi = season == null ? 1325 : this.seasons;
      try {
        let tournamentsUrl = this.tournamentsUrl;
        const { data } = await axios.get(tournamentsUrl);
        return data;
      } catch (e) {
        if (retries > 0) {
          return this.fetchTournaments(retries - 1);
        }
        throw new Error(e);
      }
    },
    /**
     *
     * @author Alejandro
     * @param {Array<number>} seasons - seasons ids
     * @param {number} retries - Times to retry the request
     * @return {Promise<{seasonsAndGames: *, seasonsAndTeams: *}|*|undefined>}
     */
    async fetchSeasonsGamesAndTeams(seasons, retries) {
      try {
        let gamesUrl = this.gamesUrl;
        seasons.forEach((seasonId, index) => {
          const prefix = index === 0 ? '' : '&';
          gamesUrl += `${prefix}seasons=${seasonId}`;
        });
        const {
          data: { data, teams },
        } = await axios.get(gamesUrl);
        return { seasonsAndGames: data, seasonsAndTeams: teams };
      } catch (e) {
        if (retries > 0) {
          return this.fetchSeasonsGamesAndTeams(seasons, retries - 1);
        }
        throw new Error(e);
      }
    },
    async reloadStatistics(isLoginChanged) {
      try {
        this.setIsSectionLoading(true);
        await this.cleanStats();
        if (this.$route.params.gameId || this.game.gameId) {
          await this.fillStatistics(isLoginChanged);
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    async onGameChanged(game) {
      try {
        if (this.lastGame.gameId !== game.gameId) {
          this.lastGame = game;
          await this.cleanStats();
          await this.$store.dispatch('nextGeneral/checkState', {
            gameId: game.gameId,
            currentSeasonId: game.seasonId,
            isTeamsAnalysis: true,
            defaultFilter: this.defaultFilter,
            gameInfo: game,
          });
        }
      } catch (e) {
        throw new Error(e);
      }
    },
    onClose() {
      this.updateIdAssetSelected(1);
      this.$emit('close');
    },
  },
  created() {
    try {
      window.addEventListener('resize', () => this.setSize());
      this.viewOptions = options.viewOptions;
    } catch (e) {
      throw new Error(e);
    }
  },
  mounted() {
    this.setSize();
    if (this.getPremiumAccount) connectSocket();
    this.cleanXgStore();
    this.setTeamSelected('Local');
    if (!this.isInnerComponent) {
      setTimeout(() => {
        const mainContainer = document.getElementById('matchAnalysisContainer');
        if (mainContainer) {
          mainContainer.scrollIntoView();
        }
      }, 200);
    }
  },
  beforeDestroy() {
    this.setMenuOptionActive('');
    this.$store.dispatch('nextGeneral/exitChannel');
    this.setIsSectionLoading(false);
  },
};
</script>

<style lang="scss" scoped>
/* NUEVO CSS */
.statistics {
  width: 1248px;
  height: auto;
  // background: #d6d6d6;
  display: inline-block;
  z-index: 500;
  @media screen and (max-width: 1320px) {
    width: 1180px !important;
  }
  @media screen and (max-width: 1240px) {
    width: 1080px !important;
  }
  @media screen and (max-width: 1140px) {
    max-width: 100% !important;
  }
  //@media screen and (max-width: 1040px) {
  //  width: 880px !important;
  //}
  //@media screen and (max-width: 940px) {
  //  width: 780px !important;
  //}
  //@media screen and (max-width: 840px) {
  //  width: 680px !important;
  //}
  //@media screen and (max-width: 740px) {
  //  max-width: 590px !important;
  //}
  //@media screen and (max-width: 640px) {
  //  max-width: 100% !important;
  //}
  //@media screen and (max-width: 540px) {
  //  max-width: 395px !important;
  //}
  //@media screen and (max-width: 440px) {
  //  max-width: 294px !important;
  //}
  //@media screen and (max-width: 319px) {
  //  max-width: 255px !important;
  //}
  &__bar-settings {
    width: 98%;
    height: 40px;
    margin: 0 auto;
    margin-top: 3px;
    @media screen and (max-width: 540px) {
      height: 32px;
    }
  }
  &__cont-header {
    width: 98%;
    height: 112px;
    background: #132739;
    margin: 0 auto;
    border-radius: 11px;
    margin-top: 12px;
    overflow: hidden;
    @media screen and (max-width: 540px) {
      height: 51px;
    }
  }
  &__cont-menu {
    width: 98%;
    height: 45px;
    // background: gold;
    margin: 0 auto;
    margin-top: 2px;
    @media screen and (max-width: 540px) {
      height: 29px;
    }
  }
  &__cont-sub-menu {
    width: 98%;
    height: 33px;
    margin: 0 auto;
    margin-top: 24px;
    @media screen and (max-width: 540px) {
      margin-top: 8px;
      height: 25px;
    }
  }
  &__cont-sections {
    width: 98%;
    height: auto;
    margin: 0 auto;
    margin-top: 24px;
  }
}
/* --------- */
.main-container {
  margin: 0px 0 0 0;
  display: flex;
  justify-content: center;
  width: 100%;
  //overflow: no-display !important;
  .is-bordered-box-shadow-main {
    position: relative;
    padding-bottom: 30px;
    margin: 0px 0 0 0;
  }
}
@media screen and (max-width: 768px) {
  .main-container {
    padding: 0 5px 0 5px !important;
  }
}
.next-games-container {
  margin: 0 10px;
  padding: 0px 5px 0 5px;
  min-height: 400px;
  width: 1248px !important;
  // @media (min-width: 1100px) {
  //   width: 900px !important;
  // }
  // @media (min-width: 900px) {
  //   width: 800px !important;
  // }
}
.container-view.mobile {
  margin: 0px 0.7rem;
}
.flex-container {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 0;
}
.flex-item {
  cursor: pointer;
  font-family: 'Avenir-Demi';
  font-size: 0.75rem;
  width: 50%;
  padding-top: 6%;
  padding-bottom: 6%;
  text-align: center;
  align-items: center;
  display: flex;
  justify-content: center;
  border-radius: 4px;
  /* border: 1px solid silver;*/
}
.menu-left {
  margin-left: 0.1rem;
  padding: 0 5px 0 5px;
}
.view-container-title {
  font-family: 'Circular-Std';
  background-color: #001d57;
  color: white;
  align-items: center;
  justify-content: center;
}
.match-live-notification {
  font-family: 'Circular-Std';
  font-size: 0.875em;
  padding: 6px 16px;
  width: 65px;
  height: 30px;
  opacity: 0.8;
  border-radius: 6px;
  border: solid 1px #ffffff;
  color: #ffffff;
}
.custom-section-container {
  padding: 0 2rem;
}
/* Olds Styles*/
.card {
  margin: 3rem;
  padding: 3rem;
}
.head {
  background-color: #001445;
  color: aliceblue;
  border-top: 1px solid;
  border-color: black;
}
.main-s {
  background-color: #77ba3f;
  color: aliceblue;
  border-top: 1px solid;
  border-color: black;
}
.main-s h4 {
  color: white;
}
.main {
  border-top: 1px solid;
  border-color: black;
}
.head h1 {
  color: white;
}
.container {
  margin: 3rem;
}
.row {
  background-color: transparent;
  border-color: transparent;
  padding: 2px;
  width: 90%;
}
.panel {
  padding-bottom: 2rem;
}
.advance {
  font-size: 3rem;
}
.icon-down {
  color: crimson;
}
.icon-up {
  color: green;
}
.advanced {
  background-color: #7ed321;
  color: white;
}
.item.a {
  margin-bottom: 0px;
}
.disabled {
  pointer-events: none;
  /* for "disabled" effect */
  opacity: 0.5;
}
.tournament {
  padding-right: 10px;
  &__logo {
    height: 26px;
    width: 100%;
    & > img {
      height: 100%;
    }
  }
  & > hr {
    margin: 12px 0 12px;
    width: 100%;
    height: 1px;
    border-width: 0;
    color: #d5cfcf;
    background-color: #d5cfcf;
  }
}
@media screen and (max-width: 768px) {
  .container-view {
    margin: 0 0rem;
    background-color: white;
  }
  .container-view.mobile {
    margin: 0px 0rem;
  }
  .main-container {
    margin: 0px;
    display: flex;
    justify-content: center;
    .is-bordered-box-shadow-main {
      margin: 0;
      padding-bottom: 0;
    }
    .next-matches-title {
      font-family: 'Avenir-Demi';
      font-size: 1.2rem;
      margin: 0 0 10px 0;
      color: #6f7072;
    }
  }
  .next-games-container {
    margin: 0;
    padding: 15px 0 15px 0;
  }
  .child-container {
    padding: 15px;
    margin-top: 10px;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
@media screen and (max-width: 500px) {
  .child-container {
    margin: 5px !important;
    padding: 2px !important;
  }
}
@media screen and (max-width: 400px) {
  .child-container {
    margin: 5px !important;
    padding: 1px !important;
  }
}
@media screen and (max-width: 400px) and (min-width: 300px) {
  .general {
    width: 98vw;
  }
}
</style>
